module.exports = __webpack_public_path__ + "8a72e3d44d111be6e1cb1f2da2607801.MP3";